var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-10",attrs:{"align":"center"}},[_c('v-img',{staticClass:"mx-auto my-5",attrs:{"width":"200PX","src":require("@/assets/NUMAZU_DISTILLERY_square_white.png")}}),_c('s-n-s-buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }